import Skrollite from '../../../components/skrollite/script';

export default class RoutingCaseStudySlider {

	static selector = 'routing-case-study-slider';

	// class variables

	el = {};

	components = {
		skrollite: null
	};

	activeSlideClass = `${this.constructor.selector}__slide--active`;

	activeDotClass = `${this.constructor.selector}__dot--active`;

	// constructor

	constructor(container) {
		this.el = {
			container,
			arrowLeft: container.querySelector(`.${this.constructor.selector}__arrow-left`),
			arrowRight: container.querySelector(`.${this.constructor.selector}__arrow-right`),
			slides: container.querySelectorAll(`.${this.constructor.selector}__slide`),
			activeSlide: container.querySelector(`.${this.constructor.selector}__slide--active`),
			dots: container.querySelectorAll(`.${this.constructor.selector}__dot a`),
			activeDot: container.querySelector(`.${this.constructor.selector}__dot--active a`)
		};
		this.components.skrollite = new Skrollite();
		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		if (this.el.arrowLeft && this.el.arrowRight && this.el.dots) {
			this.el.arrowLeft.addEventListener('click', this.#onArrowLeftClick);
			this.el.arrowRight.addEventListener('click', this.#onArrowRightClick);
			this.el.dots.forEach((dot) => {
				dot.addEventListener('click', this.#onDotClick);
			});
		}
	}

	#removeEventListeners = () => {
		this.el.arrowLeft.removeEventListener('click', this.#onArrowLeftClick);
		this.el.arrowRight.removeEventListener('click', this.#onArrowRightClick);
	}

	// listener methods

	#onArrowLeftClick = (event) => {
		event.preventDefault();
		this.slide('left');
		return false;
	}

	#onArrowRightClick = (event) => {
		event.preventDefault();
		this.slide('right');
		return false;
	}

	#onDotClick = (event) => {
		event.preventDefault();
		const slideIndex = parseInt(event.target.dataset.slideIndex);
		if (slideIndex === parseInt(this.el.activeDot.dataset.slideIndex)) {
			return false;
		}
		this.slide(slideIndex);
		return true;
	}

	clearSkrolliteAnimations = () => {
		this.el.container.querySelectorAll('.is-in-viewport').forEach((item) => {
			item.classList.remove('is-in-viewport', 'is-first-in', 'is-on-screen', 'is-not-first');
		});
	}

	// slider methods

	slide = (dirDex) => {

		// Strip active classes
		this.el.activeSlide.classList.remove(this.activeSlideClass);
		this.el.activeDot.parentElement.classList.remove(this.activeDotClass);

		// Set Active slide
		switch (dirDex) {
			case 'left':
				if (this.el.activeSlide.previousElementSibling) {
					this.el.activeSlide = this.el.activeSlide.previousElementSibling;
				} else {
					this.el.activeSlide = this.el.activeSlide.parentNode.lastElementChild;
				}
				break;
			case 'right':
				if (this.el.activeSlide.nextElementSibling) {
					this.el.activeSlide = this.el.activeSlide.nextElementSibling;
				} else {
					this.el.activeSlide = this.el.activeSlide.parentNode.firstElementChild;
				}
				break;

			default:
				if (Number.isInteger(dirDex)) {
					this.el.activeSlide = this.el.slides[dirDex];
				}
				break;
		}

		// Set active dot based on active slide
		this.el.slides.forEach((slide, index) => {
			if (slide === this.el.activeSlide) {
				this.el.activeDot = this.el.dots[index];
			}
		});

		// Re-add active classes
		this.el.activeDot.parentElement.classList.add(this.activeDotClass);
		this.el.activeSlide.classList.add(this.activeSlideClass);
		this.clearSkrolliteAnimations();
		this.components.skrollite.pageUpdate();
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
